// Clevertap account ID
export const QA_CLEVERTAP_ID = 'TEST-8WW-9K9-W94'
export const PROD_CLEVERTAP_ID = 'W8R-KK8-W74Z'
